import { render, staticRenderFns } from "./PromotionRegistration.vue?vue&type=template&id=698e0d3e&scoped=true&"
import script from "./PromotionRegistration.vue?vue&type=script&lang=js&"
export * from "./PromotionRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PromotionRegistration.vue?vue&type=style&index=0&id=698e0d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698e0d3e",
  null
  
)

export default component.exports